import React from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  Typography,
  Divider,
} from '@mui/material';
import {
  Dashboard,
  CalendarToday,
  People,
  Assignment,
  Assessment,
  Settings,
} from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import Logo from './Logo';

const drawerWidth = 260;

const menuItems = [
  { text: 'Dashboard', icon: Dashboard, path: '/dashboard' },
  { text: 'Schedule', icon: CalendarToday, path: '/schedule' },
  { text: 'Staff', icon: People, path: '/staff' },
  { text: 'Leave', icon: Assignment, path: '/leave' },
  { text: 'Reports', icon: Assessment, path: '/reports' },
  { text: 'Settings', icon: Settings, path: '/settings' },
];

const Sidebar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          bgcolor: '#1a1a2e',
          color: 'white',
          borderRight: '1px solid rgba(255, 255, 255, 0.1)',
        },
      }}
      variant="permanent"
      anchor="left"
    >
      <Box sx={{ p: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
        <Logo size={40} />
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 700, color: 'white', lineHeight: 1 }}>
            Sakura
          </Typography>
          <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.6)' }}>
            ShiftSync
          </Typography>
        </Box>
      </Box>
      
      <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.1)' }} />
      
      <List sx={{ pt: 2 }}>
        {menuItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <ListItem key={item.text} disablePadding>
              <ListItemButton
                onClick={() => navigate(item.path)}
                sx={{
                  mx: 1,
                  my: 0.5,
                  borderRadius: 2,
                  bgcolor: isActive ? 'rgba(233, 30, 99, 0.2)' : 'transparent',
                  '&:hover': {
                    bgcolor: 'rgba(233, 30, 99, 0.1)',
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    color: isActive ? '#E91E63' : 'rgba(255, 255, 255, 0.6)',
                    minWidth: 40,
                  }}
                >
                  <item.icon />
                </ListItemIcon>
                <ListItemText
                  primary={item.text}
                  primaryTypographyProps={{
                    sx: {
                      color: isActive ? '#E91E63' : 'rgba(255, 255, 255, 0.8)',
                      fontWeight: isActive ? 600 : 400,
                    },
                  }}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
      
      <Box sx={{ mt: 'auto', p: 3 }}>
        <Box
          sx={{
            p: 2,
            borderRadius: 3,
            bgcolor: 'rgba(233, 30, 99, 0.1)',
            border: '1px solid rgba(233, 30, 99, 0.2)',
          }}
        >
          <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.6)' }}>
            Need help?
          </Typography>
          <Typography variant="body2" sx={{ color: 'white', fontWeight: 600, mt: 1 }}>
            Contact Support
          </Typography>
        </Box>
      </Box>
    </Drawer>
  );
};

export default Sidebar;
